export { default } from './CommentsOut';



// WEBPACK FOOTER //
// ./src/components/Comment/ReducerWrappers/CommentsOut/index.js